/* =================== DEPOIMENTOS =================== */
jQuery(document).ready(function($) {
  $(".carrosel-depoimentos").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 760,
        settings: "unslick"
      }
    ]
  });
});
